import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Text, Hide } from 'pcln-design-system'
import { ANCILLARIES, HIDE } from './constants'

const AncillaryLegend = ({ ancillaries, showDesktop }) => {
  const singleAncillaries = ancillaries.map((ancillary) => (
    <Flex key={ancillary.label} mr={showDesktop && 3} alignItems='center' mb={1}>
      <ancillary.Icon size={16} />
      <Text ml={showDesktop ? 1 : 2} fontSize={0}>
        {ancillary.label}
      </Text>
    </Flex>
  ))

  return showDesktop ? (
    <Flex mb={1} px={['16px', '16px', '16px', '16px', 0]}>
      {' '}
      {singleAncillaries}{' '}
    </Flex>
  ) : (
    <Hide {...HIDE} mb='14px' px={['16px', '16px', '16px', '16px', 0]}>
      {singleAncillaries}
    </Hide>
  )
}

AncillaryLegend.defaultProps = {
  ancillaries: ANCILLARIES,
}

AncillaryLegend.propTypes = {
  showDesktop: PropTypes.bool,
  ancillaries: PropTypes.arrayOf(
    PropTypes.shape({
      Icon: PropTypes.node,
      label: PropTypes.string,
    })
  ),
}

export { AncillaryLegend }
